import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = {
  bots: [],
  selectedBot: {},
  loading: false,
};

export const getBotsAsync = createAsyncThunk('bots/addBot', async () => {
  try {
    const response = await axios.get('/api/showcase.bot');
    return response.data;
  } catch (error) {
    console.error(error);

    throw error;
  }
});

const botSlice = createSlice({
  name: 'bot',
  initialState,
  reducers: {
    updateSelectedBot: (state, action) => {
      state.selectedBot = action?.payload?.selectedBot;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getBotsAsync.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(getBotsAsync.rejected, (state) => {
      state.loading = true;
    });
    builder.addCase(getBotsAsync.fulfilled, (state, action) => {
      state.bots = action.payload && action.payload.bots;
      state.selectedBot = action.payload && action.payload.bots?.[0];
      state.loading = false;
    });
  },
});

export const { updateSelectedBot } = botSlice.actions;

export default botSlice.reducer;
